import { put, call } from 'redux-saga/effects';
import { END_POINTS } from '../../api/endpoints';
import { API } from '../../api/api';
import { getConsultationObservationFailureAction, getConsultationObservationSuccessAction, getFollowUpTestFailureAction, getFollowUpTestSuccessAction, getPatientNextConsultationTestFailureAction, getPatientNextConsultationTestSuccessAction, getRecommendedAdditionalTestFailureAction, getRecommendedAdditionalTestSuccessAction } from '../actions/consultationScheduleActions';
import { createConsultationFailureAction, createConsultationSuccessAction, createUpdateTreatmentFailureAction, createUpdateTreatmentSuccessAction, endConsultationFailureAction, endConsultationSuccessAction, getTreatmentFailureAction, getTreatmentSuccessAction, updateConsultationFailureAction, updateConsultationSuccessAction, updatePhysicalDataFailureAction, updatePhysicalDataSuccessAction } from '../actions/consultationActions';

// ------ get patient details ------

export function* getNextConsultationTextSchedule(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const consultationScheduleResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.nextConsultationSchedule(action.payload.patientId)}`,
        );

        if (!consultationScheduleResponse.success) {
            throw new Error(consultationScheduleResponse.message)
        }
        yield put(getPatientNextConsultationTestSuccessAction(consultationScheduleResponse.data));
    } catch (error) {
        yield put(getPatientNextConsultationTestFailureAction(error.message));
    }
}

// ------ get additional recommended test ------

export function* getRecommendedAdditionalTests(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const testResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.getRecommendedAdditionalTest(action.payload.consultationId)}`,
        );

        if (!testResponse.success) {
            throw new Error(testResponse.message)
        }
        yield put(getRecommendedAdditionalTestSuccessAction(testResponse.data));
    } catch (error) {
        yield put(getRecommendedAdditionalTestFailureAction(error.message));
    }
}

// ------ get RECOMMENDED FOLLOW UP test ------

export function* getRecommendedFollowUpTests(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const testResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.getFollowUpTest(action.payload.consultationId)}`,
        );

        if (!testResponse.success) {
            throw new Error(testResponse.message)
        }
        yield put(getFollowUpTestSuccessAction(testResponse.data));
    } catch (error) {
        yield put(getFollowUpTestFailureAction(error.message));
    }
}

// ------ get RECOMMENDED FOLLOW UP test ------

export function* getTreatmentList(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const treatmentResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.treatmentList(action.payload.patientId)}`,
        );

        if (!treatmentResponse.success) {
            throw new Error(treatmentResponse.message)
        }
        yield put(getConsultationObservationSuccessAction(treatmentResponse.data));
    } catch (error) {
        yield put(getConsultationObservationFailureAction(error.message));
    }
}

// ------ create consultation for patient ------

export function* createConsultation(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const consultationResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.createConsulation}`,
            {
                ...action.payload
            }
        );

        if (!consultationResponse.success) {
            const message = consultationResponse.errorCode === 'APPOINTMENT_NOT_CHECKED_IN'
                ? 'Please check in the patient before starting consultation'
                : consultationResponse.message;
            yield put(createConsultationFailureAction(message));
            return;
        }
        yield put(createConsultationSuccessAction(consultationResponse.data));
    } catch (error) {
        yield put(createConsultationFailureAction(error.message));
    }
}

export function* updateConsultation(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const consultationResponse = yield call(
            API.put,
            `${baseUrl}${END_POINTS.updateConsultation(action.payload.consultationId)}`,
            {
                ...action.payload.body?.[action.payload.consultationId]
            }
        );

        if (!consultationResponse.success) {
            throw new Error(consultationResponse.message)
        }
        yield put(updateConsultationSuccessAction(consultationResponse.data));
    } catch (error) {
        yield put(updateConsultationFailureAction(error.message));
    }
}

export function* getTreatmentDetails(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const treatmentResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.getTreatment(action.payload.consultationId)}`,
        );

        if (!treatmentResponse.success) {
            throw new Error(treatmentResponse.message)
        }
        yield put(getTreatmentSuccessAction(treatmentResponse.data));
    } catch (error) {
        yield put(getTreatmentFailureAction(error.message));
    }
}

export function* createUpdateTreatmentDetails(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const treatmentResponse = yield call(
            API.put,
            `${baseUrl}${END_POINTS.createUpdateTreatment(action.payload.consultationId)}`,
            {
                ...action.payload.body
            }
        );

        if (!treatmentResponse.success) {
            throw new Error(treatmentResponse.message)
        }
        yield put(createUpdateTreatmentSuccessAction(treatmentResponse.data));
    } catch (error) {
        yield put(createUpdateTreatmentFailureAction(error.message));
    }
}

export function* endConsultation(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const consultationResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.endConsultation(action.payload.consultationId)}`,
        );

        if (!consultationResponse.success) {
            throw new Error(consultationResponse.message)
        }
        yield put(endConsultationSuccessAction(consultationResponse.data));
    } catch (error) {
        yield put(endConsultationFailureAction(error.message));
    }
}

export function* createUpdatePhysicalData(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const physicalResponse = yield call(
            API.put,
            `${baseUrl}${END_POINTS.createUpdatePhysical(action.payload.consultationId)}`,
            {
                ...action.payload.body
            }
        );

        if (!physicalResponse.success) {
            throw new Error(physicalResponse.message)
        }
        yield put(updatePhysicalDataSuccessAction(physicalResponse.data));
    } catch (error) {
        yield put(updatePhysicalDataFailureAction(error.message));
    }
}
